import Page from '@modules/landingpage/pages/default';
import getSSRProps from '@modules/landingpage/pages/default/ssr';

export const getServerSideProps = async (ctx) => getSSRProps(ctx);
export default Page;
